import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import UISection from 'UIComponents/section/UISection';
import UIList from 'UIComponents/list/UIList';
import ReviewBody from 'marketplace-ui-reviews/components/ReviewBody';
import ReviewerInfo from 'marketplace-ui-reviews/components/ReviewerInfo';
import QualityDistribution from 'marketplace-ui-reviews/components/QualityDistribution';
import ReviewReplyThread from 'marketplace-ui-reviews/components/ReviewReplyThread';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import Rating from 'marketplace-ui-reviews/components/Rating';
import * as ReviewTypes from 'marketplace-ui-reviews/constants/ReviewType';
import { RatingAxes } from 'marketplace-ui-reviews/constants/RatingAxes';
// @ts-expect-error untyped dependency
import withReportModalState from './withReportModalState';

// Renders a complete review item given a review. ReviewsList iterates through
// a list of reviews and calls the Renderer to display each one
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AllReviewsRenderer({
  borderBottom,
  isCustomer,
  onReplyModalOpen,
  review,
  reviewModalOpen,
  replyModalOpen,
  reportReviewModal,
  reportReplyModal,
  reviewActionsList,
  searchTerm,
  showOriginal
}) {
  const {
    gridClassName
  } = useResponsiveProps({
    gridClassName: {
      xs: 'flex-column m-bottom-4',
      sm: 'flex-row justify-between align-top m-bottom-4',
      md: 'flex-column'
    }
  });
  const rating = showOriginal ? review.get('original').ratings.get('OVERALL') : review.getIn(['ratings', RatingAxes.OVERALL]);
  return /*#__PURE__*/_jsxs(UIGrid, {
    className: "p-y-8",
    style: {
      width: '100%',
      borderBottom: borderBottom ? `1px solid ${GREAT_WHITE}` : undefined
    },
    children: [/*#__PURE__*/_jsxs(UIGridItem, {
      size: {
        xs: 12,
        md: 5,
        lg: 4
      },
      className: gridClassName,
      children: [/*#__PURE__*/_jsx("div", {
        className: "m-bottom-8",
        children: /*#__PURE__*/_jsx(ReviewerInfo, {
          review: review
        })
      }), /*#__PURE__*/_jsx(QualityDistribution, {
        qualityRatings: review.getQualityRatings(showOriginal),
        reviewType: ReviewTypes.APP
      })]
    }), /*#__PURE__*/_jsxs(UIGridItem, {
      size: {
        xs: 12,
        md: 7,
        lg: 8
      },
      className: "flex-column",
      children: [/*#__PURE__*/_jsx(UISection, {
        children: /*#__PURE__*/_jsx(Rating, {
          direction: "column",
          label: /*#__PURE__*/_jsxs(UIList, {
            inline: true,
            use: "inline-divided",
            children: [/*#__PURE__*/_jsx(FormattedDateTime, {
              value: review.get('createdAt'),
              format: "ll",
              type: "userTz"
            }), review.get('lastEditedAt') && /*#__PURE__*/_jsxs("span", {
              children: [/*#__PURE__*/_jsx(FormattedMessage, {
                className: "m-right-1",
                message: "appMarketplace.detail.reviews.edit.edited"
              }), /*#__PURE__*/_jsx(FormattedDateTime, {
                value: review.get('lastEditedAt'),
                format: "ll",
                type: "userTz"
              })]
            })]
          }),
          rating: rating,
          showTextRating: true
        })
      }), /*#__PURE__*/_jsx(ReviewBody, {
        review: review,
        searchTerm: searchTerm,
        showOriginal: showOriginal
      }), reviewActionsList, /*#__PURE__*/_jsx(ReviewReplyThread, {
        reply: review.get('reply'),
        onReportReplyClick: isCustomer ? onReplyModalOpen : undefined
      }), reviewModalOpen && reportReviewModal, replyModalOpen && reportReplyModal]
    })]
  });
}
export default withReportModalState(AllReviewsRenderer);